// extracted by mini-css-extract-plugin
export default {"prompt":"prompt__Bh8T3","textSegment":"textSegment__ow7kr","dropdownSegment":"dropdownSegment__J_wbD"};